import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  console.error('[Vue Error]', err, info)
  // 可扩展：上报到监控服务（如 Sentry）
}

Vue.config.warnHandler = (msg, vm, trace) => {
  console.warn('[Vue Warn]', msg, trace)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
